import type { LiveV1ComplianceStatusReply } from '../../types';

export type ComplianceStep = 'identity' | 'minor' | 'senior' | 'ready';

export interface IdentityFormError {
  realName?: string;
  idNumber?: string;
  form?: string;
}

export interface ContactFormError {
  phone?: string;
  form?: string;
}

export function getComplianceStep(status: LiveV1ComplianceStatusReply): ComplianceStep {
  if (status.can_enter) return 'ready';

  const identity = status.identity;
  if (!identity?.verified || identity.verify_status === 'not_started' || identity.verify_status === 'failed') {
    return 'identity';
  }
  if (identity.age_group === 'minor') return 'minor';
  if (identity.age_group === 'unknown' || identity.age_group === 'unspecified') return 'identity';
  if (identity.age_group === 'senior' && !status.senior_notice?.confirmed) return 'senior';
  // 紧急联系人步骤已移除，直接返回 ready
  return 'ready';
}

export function getIdentityFormError(reason?: string): IdentityFormError {
  switch (reason) {
    case 'LiveInvalidRealName':
      return { realName: '请输入正确的姓名' };
    case 'LiveInvalidIDNo':
      return { idNumber: '请输入正确的身份证号码' };
    case 'LiveIdentityVerifyFailed':
      return { form: '姓名与身份证号码不匹配，请检查后重试。' };
    case 'LiveIdentityProviderUnavailable':
      return { form: '实名认证服务暂不可用，请稍后重试。' };
    case 'LiveAgeUnknown':
      return { form: '暂无法确认您的年龄，请检查姓名和身份证号码后重试。' };
    default:
      return { form: '实名认证失败，请检查信息后重试。' };
  }
}

export function isValidChineseIdNumber(value: string): boolean {
  const idNumber = value.trim().toUpperCase();
  if (!/^\d{17}[\dX]$/.test(idNumber)) return false;
  if (!hasValidChineseIdBirthDate(idNumber.slice(6, 14))) return false;
  return hasValidChineseIdChecksum(idNumber);
}

function hasValidChineseIdBirthDate(value: string): boolean {
  const year = Number(value.slice(0, 4));
  const month = Number(value.slice(4, 6));
  const day = Number(value.slice(6, 8));
  const date = new Date(year, month - 1, day);
  const today = new Date();
  return (
    date.getFullYear() === year &&
    date.getMonth() === month - 1 &&
    date.getDate() === day &&
    date.getTime() <= today.getTime()
  );
}

function hasValidChineseIdChecksum(idNumber: string): boolean {
  const weights = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];
  const codes = '10X98765432';
  const sum = weights.reduce((total, weight, index) => total + Number(idNumber[index]) * weight, 0);
  return idNumber[17] === codes[sum % 11];
}

export function isValidChineseMobileNumber(value: string): boolean {
  return /^1[3-9]\d{9}$/.test(value.trim());
}
